import { mpfRListsHttp } from '../../api/mpf-r-lists-http'
import { isArchivedFilter } from '../data'

interface PIIScanListMetadataArgs {
  isArchivedFilter: false | null | true
  isAscending?: boolean
  orderBy?: string
}
interface PIIScanList {
  EKey?: string
  ETag?: string
  ExtraData: string
  FindingString: string
  ItemCreated?: Date
  ItemCreatedBy?: any
  'ItemCreatedBy/edipi'?: string
  'ItemCreatedBy/email'?: string
  'ItemCreatedBy/firstname'?: string
  'ItemCreatedBy/lastname'?
  ItemGUID: string
  ItemModified?: Date
  ItemModifiedBy?: any
  'ItemModifiedBy/edipi'?: string
  'ItemModifiedBy/email'?: string
  'ItemModifiedBy/firstname'?: string
  'ItemModifiedBy/latname'?: string
  RecordsScanned: number
  ScanCode: number
  ScanCreatedByUser: any
  ScanCreatedDate: Date
  ScanOccuranceRecordsDetected: number
  ScanRecordsDetected: number
  ScanStatus: string
}

const LIST_NAME = 'PIIScanList'
const COLUMN_NAMES = {
  ETag: 'eTag',
  Ekey: 'eKey',
  ExtraData: 'ExtraData',
  FindingString: 'FindingString',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemCreatedByEDIPI: 'ItemCreatedBy/edipi',
  ItemCreatedByEmail: 'ItemCreatedBy/email',
  ItemCreatedByFirstName: 'ItemCreatedBy/firstname',
  ItemCreatedByLastName: 'ItemCreatedBy/lastname',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  ItemModifiedByEDIPI: 'ItemModifiedBy/edipi',
  ItemModifiedByEmail: 'ItemModifiedBy/email',
  ItemModifiedByFirstName: 'ItemModifiedBy/firstname',
  ItemModifiedByLastName: 'ItemModifiedBy/lastname',
  RecordsScanned: 'RecordsScanned',
  ScanCode: 'ScanCode',
  ScanCreatedByUser: 'ScanCreatedByUser',
  ScanCreatedDate: 'ScanCreatedDate',
  ScanOccuranceRecordsDetected: 'ScanOccuranceRecordsDetected',
  ScanRecordsDetected: 'ScanRecordsDetected',
  ScanStatus: 'ScanStatus',
}

const getPIIScanListMetadata = async (
  args: PIIScanListMetadataArgs
): Promise<PIIScanList[]> => {
  const list = await mpfRListsHttp().getList(LIST_NAME)
  const filter = isArchivedFilter(args.isArchivedFilter)
  const ascending = args?.isAscending ?? true
  const orderBy = args?.orderBy ?? COLUMN_NAMES.ItemModified

  const items = await list
    .query()
    .filter(filter)
    .select(
      COLUMN_NAMES.ETag,
      COLUMN_NAMES.Ekey,
      COLUMN_NAMES.ExtraData,
      COLUMN_NAMES.FindingString,
      COLUMN_NAMES.ItemCreated,
      COLUMN_NAMES.ItemCreatedBy,
      COLUMN_NAMES.ItemCreatedByEDIPI,
      COLUMN_NAMES.ItemCreatedByEmail,
      COLUMN_NAMES.ItemCreatedByFirstName,
      COLUMN_NAMES.ItemCreatedByLastName,
      COLUMN_NAMES.ItemModified,
      COLUMN_NAMES.ItemModifiedBy,
      COLUMN_NAMES.ItemModifiedByEDIPI,
      COLUMN_NAMES.ItemModifiedByEmail,
      COLUMN_NAMES.ItemModifiedByFirstName,
      COLUMN_NAMES.ItemModifiedByLastName,
      COLUMN_NAMES.RecordsScanned,
      COLUMN_NAMES.ScanCode,
      COLUMN_NAMES.ScanCreatedByUser,
      COLUMN_NAMES.ScanCreatedDate,
      COLUMN_NAMES.ScanOccuranceRecordsDetected,
      COLUMN_NAMES.ScanRecordsDetected,
      COLUMN_NAMES.ScanStatus
    )
    .expand('ItemCreatedBy', 'ItemModifiedBy')
    .orderBy([{ ascending: ascending, orderBy: orderBy }])
    .get()

  return [...items] as PIIScanList[]
}
export {
  COLUMN_NAMES,
  LIST_NAME,
  type PIIScanList,
  type PIIScanListMetadataArgs,
  getPIIScanListMetadata,
}
